export async function fetchRuntimeJson(path, fallback = null) {
    try {
        const response = await fetch(path, { cache: 'no-store' });
        if (!response.ok) {
            throw new Error(`Failed to fetch ${path}: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error(`Error loading runtime JSON from ${path}:`, error);
        return fallback;
    }
}
